import React from 'react';
import PropTypes from 'prop-types';

const LocationPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M16 3c4.5 0 9 3.5 9 9.5 0 5.23-2.884 10.78-8.653 16.65a.498.498 0 0 1-.347.15.498.498 0 0 1-.347-.15C9.884 23.28 7 17.73 7 12.5c0-6 4.5-9.5 9-9.5zm0 14a5 5 0 1 0 0-10 5 5 0 0 0 0 10z"
    />
  );
};

LocationPath.propTypes = {
  fill: PropTypes.string,
};

export default LocationPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/technology/location.jsx